import React from "react";
import { withRouter } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import CachedIcon from "@material-ui/icons/Cached";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import Box from "../../../../../../ui/Box";
import SquareButton from "../../../../../../ui/SquareButton";
import Button from "../../../../../../ui/Button";
import ActionsMenu from "../../../../../../ui/ActionsMenu";
import UndoIcon from '@material-ui/icons/Undo';

const useStyles = makeStyles(() => ({
  topBar: {
    display: "flex",
    justifyContent: "space-between"
  },
  topBarLeft: {
    display: "flex",
    "& > button": {
      marginRight: 12
    }
  },
  topBarRight: {
    display: "flex",
    "& > div": {
      marginLeft: 12
    }
  }
}));

const TopBar = ({
  reload,
  returnBack,
  update,
  isUpdating,
  openDeleteModal,
  cloneSkill,
  disabled,
  statusId,
  handleToExpertize,
  handleToPublish
}) => {
  const classes = useStyles();

  const actions = [
    {
      label: "Создать копию",
      onClick: cloneSkill
    },
    {
      label: "Удалить",
      onClick: openDeleteModal
    }
  ];

  const ActionButton = ({ statusId }) => {
    if (statusId === 1 || statusId === 2 || statusId === 4) {
      return (
        <Button onClick={handleToExpertize} color="blue">
          НА ЭКСПЕРТИЗУ
        </Button>
      );
    } else if (statusId === 3) {
      return (
        <Button onClick={handleToPublish} color="green">
          ОПУБЛИКОВАТЬ
        </Button>
      );
    } else {
      return <></>;
    }
  };

  return (
    <Box>
      <div className={classes.topBar}>
        <div className={classes.topBarLeft}>
          <SquareButton onClick={returnBack}>
            <ChevronLeftIcon fontSize="small" />
          </SquareButton>
          <SquareButton onClick={reload}>
            <CachedIcon fontSize="small" />
          </SquareButton>
        </div>
        <div className={classes.topBarRight}>
          <Button
            onClick={update}
            disabled={disabled}
            loading={isUpdating}
            color="green"
          >
            Сохранить
          </Button>
          <ActionButton statusId={statusId} />
          <ActionsMenu actions={actions} />
        </div>
      </div>
    </Box>
  );
};

export default withRouter(TopBar);
